import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  FormControlLabel,
  Radio,
  RadioGroup,
  Stack,
  TextField,
  Typography,
} from "@mui/material";
import { useEffect, useState } from "react";

export const OssActionProcessDialog = ({ open, item, loading, onClose, onSubmit }) => {
  const [note, setNote] = useState("");
  const [mode, setMode] = useState("DONE");
  const [nextCheckDate, setNextCheckDate] = useState("");

  useEffect(() => {
    if (open) {
      setNote("");
      setMode("DONE");
      setNextCheckDate("");
    }
  }, [open]);

  if (!item) return null;
  const isFollowUp = mode === "FOLLOW_UP";
  const tomorrow = new Date();
  tomorrow.setDate(tomorrow.getDate() + 1);
  const tomorrowValue = new Date(tomorrow.getTime() - tomorrow.getTimezoneOffset() * 60000).toISOString().slice(0, 10);
  const submitDisabled = loading || (isFollowUp && (!nextCheckDate || !note.trim()));

  return (
    <Dialog open={open} onClose={loading ? undefined : onClose} maxWidth="sm" fullWidth>
      <DialogTitle sx={{ fontSize: "19px !important", fontWeight: "800 !important" }}>
        조치 처리
      </DialogTitle>
      <DialogContent sx={{ pt: "8px !important" }}>
        <Stack spacing={1.3}>
          <Box sx={{ p: 1.3, border: "1px solid #e5e7eb", borderRadius: "8px", bgcolor: "#fbfbfe" }}>
            <Typography sx={{ fontSize: 14.5, fontWeight: 800, color: "#111827" }}>
              {item.exception_title}
            </Typography>
            <Typography sx={{ mt: 0.25, fontSize: 12.5, color: "#64748b" }}>
              {item.order_no} · {item.item_name_snapshot}
            </Typography>
          </Box>
          <RadioGroup
            row
            value={mode}
            onChange={(event) => setMode(event.target.value)}
            sx={{
              px: 0.5,
              "& .MuiFormControlLabel-label": { fontSize: 13.5, color: "#374151" },
            }}
          >
            <FormControlLabel value="DONE" control={<Radio size="small" />} label="완료 처리" />
            <FormControlLabel value="FOLLOW_UP" control={<Radio size="small" />} label="다시 확인 필요" />
          </RadioGroup>
          {isFollowUp && (
            <TextField
              label="다음 확인일"
              type="date"
              value={nextCheckDate}
              onChange={(event) => setNextCheckDate(event.target.value)}
              size="small"
              InputLabelProps={{ shrink: true }}
              inputProps={{ min: tomorrowValue }}
              helperText="내일 이후 날짜를 선택하면, 해당 날짜에 조치 필요 목록에 다시 표시됩니다."
            />
          )}
          <TextField
            label="조치 메모"
            value={note}
            onChange={(event) => setNote(event.target.value)}
            multiline
            minRows={3}
            placeholder={isFollowUp ? "현재 확인 내용과 다시 확인해야 하는 이유를 입력" : "확인 결과와 처리 내용을 입력"}
            required={isFollowUp}
            helperText={isFollowUp ? "다시 확인 필요를 선택한 경우 조치 메모를 반드시 입력해야 합니다." : " "}
          />
        </Stack>
      </DialogContent>
      <DialogActions sx={{ px: 2.5, py: 1.6, borderTop: "1px solid #e5e7eb" }}>
        <Button onClick={onClose} color="inherit" disabled={loading}>취소</Button>
        <Button
          variant="contained"
          disabled={submitDisabled}
          onClick={() =>
            onSubmit({
              actionStatus: isFollowUp ? "IN_PROGRESS" : "DONE",
              resultNote: note || (isFollowUp ? `${item.exception_title} 재확인 예약` : `${item.exception_title} 완료 처리`),
              nextCheckDate: isFollowUp ? nextCheckDate : undefined,
              checkResult: isFollowUp ? "UNDECIDED" : "ON_SCHEDULE",
            })
          }
        >
          {isFollowUp ? "다시 확인 예약" : "완료 처리"}
        </Button>
      </DialogActions>
    </Dialog>
  );
};
